import { useState, useContext, useEffect } from 'react'
import { AnexosContext } from '../../../contexts/anexosProvider'
import { editLinhas, editLinhasComponentMap } from '../../General/Format/anexo'
import { BiX } from "react-icons/bi";

const LinhasEdit = ({ closeEditModal, linha }) => {
    const { updateLinhaById } = useContext(AnexosContext)
    const [editData, setEditData] = useState({})
    const [type, setType] = useState('Geral')

    useEffect(() => {
        setEditData(linha)
    }, [])

    const handleInputChange = (e) => {
        setEditData({ ...editData, [e.target.name]: e.target.value })
    }

    const handleSaveClick = () => {
        updateLinhaById(editData)
        closeEditModal()
    }

    const handleCancelClick = () => {
        setType('Geral')
    }
    const handleEditClick = () => {
        setType('Edit')
        setEditData(linha)
    }

    const dados = editLinhas(editData)
    const linhasComponentMap = editLinhasComponentMap(handleInputChange, handleSaveClick, handleCancelClick, handleEditClick, closeEditModal)
    return (
        <div className='fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-100 p-4'>
            <div className='bg-white dark:bg-gray-800 rounded-3xl shadow-vox-2xl max-w-2xl w-full mx-4 max-h-[90vh] overflow-hidden flex flex-col'>
                {/* Header */}
                <div className='flex items-center justify-between p-6 border-b border-gray-200 dark:border-gray-700'>
                    <h1 className='text-2xl font-bold text-gray-900 dark:text-white'>
                        Editar Linha
                    </h1>
                    <button 
                        onClick={() => closeEditModal()} 
                        className='p-2 text-gray-500 hover:text-red-500 dark:text-gray-400 dark:hover:text-red-400 transition-colors duration-200 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700'
                    >
                        <BiX className='w-6 h-6' />
                    </button>
                </div>

                {/* Content */}
                <div className='flex-1 overflow-auto p-6'>
                    <div className='space-y-4'>
                        {dados.map((dado, index) => (
                            <div key={index} className='space-y-1'>
                                {linhasComponentMap[type](dado)}
                            </div>
                        ))}
                    </div>
                </div>

                {/* Footer */}
                <div className="p-6 border-t border-gray-200 dark:border-gray-700 flex justify-end space-x-3">
                    {linhasComponentMap[`buttons${type}`]()}
                </div>
            </div>
        </div>
    )
}

export default LinhasEdit
